import { NavLink, useLocation } from "react-router-dom";

import { useAuth } from "../../js/hooks/useAuth";

import { useNotifications } from "../../js/hooks/useNotifications";

import { useHubUnread } from "../../js/hooks/useHubUnread";

import NavUnread from "../messaging/NavUnread";

import { toTitleCase } from "../../js/utils/titleCase";

import { manualsUrl, JOURNEY_LINK_PROPS } from "../../js/utils/siteLinks";

import { agentNavLinks } from "../../js/navigation/deskNav";

import { tourNavId } from "@tour/film.js";



export default function AgentNav() {

  const { session } = useAuth();

  const { pathname } = useLocation();

  const links = agentNavLinks(session);

  const { clientUnread, officeUnread } = useNotifications();

  const hubUnread = useHubUnread();



  return (

    <nav className="desk-subnav" aria-label="Agent" data-tour="desk-subnav">

      <ol className="desk-subnav-list">

        {links.map((link) => (

          <li key={link.to}>

            <NavLink

              to={link.to}

              data-tour={tourNavId(link.label)}

              className={({ isActive }) => {

                const onHub = link.to.startsWith("/agent/hub") && pathname.startsWith("/agent/hub");

                return `desk-subnav-link${isActive || onHub ? " is-active" : ""}`;

              }}

            >

              {toTitleCase(link.label)}

              {link.unread === "office" ? (

                <NavUnread count={officeUnread} />

              ) : link.unread === "client" ? (

                <NavUnread count={clientUnread} />

              ) : link.unread === "hub" ? (

                <NavUnread count={hubUnread} />

              ) : null}

            </NavLink>

          </li>

        ))}

        <li>

          <a

            href={manualsUrl("agent", session)}

            className="desk-subnav-link"

            data-tour={tourNavId("User Guide")}

            {...JOURNEY_LINK_PROPS}

          >

            {toTitleCase("User Guide")}

          </a>

        </li>

      </ol>

    </nav>

  );

}


